import React from 'react';

const EditGlobalDetailsIcon = ({
  width = 32,
  height = 32,
  color = 'currentColor',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="15.9999" cy="15.9999" r="15.5" fill="#F9F9F9" stroke={color} />
    <path
      d="M9.24896 20.0964V22.3764C9.24896 22.5864 9.41396 22.7514 9.62396 22.7514H11.904C12.0015 22.7514 12.099 22.7139 12.1665 22.6389L20.3565 14.4564L17.544 11.6439L9.36146 19.8264C9.28646 19.9014 9.24896 19.9914 9.24896 20.0964ZM22.5315 12.2814C22.824 11.9889 22.824 11.5164 22.5315 11.2239L20.7765 9.46889C20.484 9.17639 20.0115 9.17639 19.719 9.46889L18.3465 10.8414L21.159 13.6539L22.5315 12.2814Z"
      fill={color}
    />
  </svg>
);

export default EditGlobalDetailsIcon;
